var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubscriptionsYellowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.2 77.028L21.141 87.353c-3.605-9.342-7.702-22.78-8.85-39.334-.491-5.9-.327-11.308-.164-16.225.164-4.097.656-7.866.984-11.144 28.189-2.95 56.542-5.736 84.73-8.686-.163 3.278-.327 6.391-.327 9.67 0 18.519 2.786 37.366 8.686 55.394z",
    fill: "#F5FF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.842 11.964c-.164 3.278-.328 6.391-.328 9.67l-85.386 10.16c.164-4.097.655-7.866.983-11.144 28.189-2.95 56.542-5.736 84.73-8.686z",
    fill: "#0C0A0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.917 35.564c-12.292-2.95-26.55 4.59-26.386 19.34.163 11.471 10.325 21.14 20.977 19.994 14.422-1.64 13.44-17.7 8.03-19.011-2.13-.492-4.588 2.458-2.457 7.047 6.227 13.93 20.977-1.475 9.341-18.52",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.817 49.495c-.492-3.114-1.311-6.391-1.803-9.505 0 0 6.556-.82 11.964 3.277M20.486 54.74c.82 9.34 2.13 18.027 7.211 26.221",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109.805c11.495 0 20.814-2.935 20.814-6.555 0-3.62-9.32-6.556-20.814-6.556-11.495 0-20.814 2.935-20.814 6.556 0 3.62 9.319 6.555 20.814 6.555z",
    fill: "#0C0A0C"
  })));
}

export default SvgSubscriptionsYellowIcon;